import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useSelector } from "react-redux";
import TournamentCard from "../../utils/tournament/tournamentCard";
import { showToast } from "../../components/ToastNotification";
import ConfirmationModal from "../../utils/general/confirmationModal";
import LoadingSpinner from "../../utils/general/LoadingSpinner";

const MyTournaments = () => {
  const token = useSelector((state) => state.user.token);
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");
  const [tournamentData, setTournamentData] = useState([]);

  // Estado para controlar el modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTournamentId, setSelectedTournamentId] = useState(null);

  const handleEdit = (tournament) => {
    console.log("Edit tournament", tournament);
  };

  const handleDeleteClick = (tournamentId) => {
    setSelectedTournamentId(tournamentId); // Guardar el ID del torneo seleccionado
    setIsModalOpen(true); // Abrir el modal
  };

  const handleDeleteConfirm = async () => {
    if (!selectedTournamentId) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/tournaments/${selectedTournamentId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Error al eliminar el torneo.");
      }

      // Actualizar el estado eliminando el torneo eliminado
      setTournamentData((prevData) =>
        prevData.filter((tournament) => tournament.id !== selectedTournamentId),
      );

      console.log("Torneo eliminado exitosamente.");
      showToast.success("Torneo eliminado exitosamente.");
    } catch (error) {
      setError("Error al eliminar el torneo.");
      console.error("Error:", error);
      showToast.error("Error al eliminar el torneo.");
    } finally {
      setIsModalOpen(false); // Cerrar el modal
      setSelectedTournamentId(null); // Limpiar el ID seleccionado
    }
  };

  const handleDeleteCancel = () => {
    setIsModalOpen(false); // Cerrar el modal sin eliminar
    setSelectedTournamentId(null); // Limpiar el ID seleccionado
  };

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  useEffect(() => {
    const fetchTournamentData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/tournaments/${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error("Error al cargar los torneos del usuario.");
        }

        const data = await response.json();
        const formattedData = Array.isArray(data)
          ? data.map((tournament) => ({
              id: tournament.id,
              imageSrc: tournament.picture_url,
              columnTitle: tournament.tournament_name,
              text1: `Torneo`,
              text2: `${tournament.tournament_type}`,
              startDate: tournament.start_date,
              endDate: tournament.end_date,
            }))
          : [];

        setTournamentData(formattedData);
      } catch (error) {
        setError("Error al cargar los torneos del usuario.");
        showToast.error(error);
      }
    };
    fetchTournamentData();
  }, [userId, token]);

  if (!tournamentData) return <LoadingSpinner />;

  return (
    <div className="max-w-[380px] mx-auto p-2">
      <h1 className="text-lg font-bold text-black mb-4">Mis Torneos</h1>
      {tournamentData.map((tournament, index) => (
        <TournamentCard
          key={index}
          tournament={tournament}
          onEdit={handleEdit}
          onDelete={() => handleDeleteClick(tournament.id)} // Pasar el ID al hacer clic
          basePath={"tournaments"}
        />
      ))}

      {/* Modal de confirmación */}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        message="¿Estás seguro de que deseas eliminar este torneo?"
      />
    </div>
  );
};

export default MyTournaments;
